import AppProvider from 'store/AppProvider';
import AppLayout from 'appLayout';

function AppWrapper() {
  return (
    <AppProvider>
      <AppLayout />
    </AppProvider>
  );
}

export default AppWrapper;
